<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Report Requests Details
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="col comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <div class="relative-position" style="min-height:100px">
                                        <template v-if="pageReady">
                                            <div class="grid">
                                                <div class="col-12">
                                                    <div class="" :class="{ 'card': !isSubPage }">
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Report Request Id: 
                                                            </div>
                                                            <div class="col font-bold">{{ item.report_request_id }}</div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Customer Id: 
                                                            </div>
                                                            <div class="col font-bold">
                                                                <Button class="p-button-text" icon="pi pi-eye" label="Customers Detail" v-if="item.customer_id" @click="app.openPageDialog({ page: 'customers/view', url: `/customers/view/${item.customer_id}` , closeBtn: true })" />
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Meter Id: 
                                                            </div>
                                                            <div class="col font-bold">
                                                                <Button class="p-button-text" icon="pi pi-eye" label="Meters Detail" v-if="item.meter_id" @click="app.openPageDialog({ page: 'meters/view', url: `/meters/view/${item.meter_id}` , closeBtn: true })" />
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Report Type: 
                                                            </div>
                                                            <div class="col font-bold">{{ item.report_type }}</div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Start Date: 
                                                            </div>
                                                            <div class="col font-bold">
                                                                <Chip v-if="item.start_date" :label="$utils.relativeDate(item.start_date)" v-tooltip="{value: $utils.humanDatetime(item.start_date)}" />
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                End Date: 
                                                            </div>
                                                            <div class="col font-bold">
                                                                <Chip v-if="item.end_date" :label="$utils.relativeDate(item.end_date)" v-tooltip="{value: $utils.humanDatetime(item.end_date)}" />
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Status: 
                                                            </div>
                                                            <div class="col font-bold">{{ item.status }}</div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Report File Type: 
                                                            </div>
                                                            <div class="col font-bold">{{ item.report_file_type }}</div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Report File Link: 
                                                            </div>
                                                            <div class="col font-bold">{{ item.report_file_link }}</div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Date Created: 
                                                            </div>
                                                            <div class="col font-bold">
                                                                <Chip v-if="item.date_created" :label="$utils.relativeDate(item.date_created)" v-tooltip="{value: $utils.humanDatetime(item.date_created)}" />
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div class="grid align-items-center">
                                                            <div class="col">
                                                                Date Updated: 
                                                            </div>
                                                            <div class="col font-bold">
                                                                <Chip v-if="item.date_updated" :label="$utils.relativeDate(item.date_updated)" v-tooltip="{value: $utils.humanDatetime(item.date_updated)}" />
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div class="flex  justify-btween">
                                                            <SplitButton class="p-button p-button-raised p-button-text p-button-sm" :model="getActionMenuModel(item)">
                                                                <i></i>
                                                            </SplitButton>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="loading">
                                            <div class="p-3 text-center">
                                                <ProgressSpinner style="width:50px;height:50px" />
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {   toRefs, onMounted } from 'vue';
	import { utils } from '@/utils';
	import { useApp } from '@/composables/app.js';
	import { useViewPage } from '@/composables/viewpage.js';
	const props = defineProps({
		id: [String, Number],
		primaryKey: {
			type: String,
			default: 'report_request_id',
		},
		pageName: {
			type: String,
			default: 'report_requests',
		},
		routeName: {
			type: String,
			default: 'report_requestsview',
		},
		apiPath: {
			type: String,
			default: 'report_requests/view',
		},
		editButton: {
			type: Boolean,
			default: true,
		},
		deleteButton: {
			type: Boolean,
			default: true,
		},
		exportButton: {
			type: Boolean,
			default: true,
		},
		titleBeforeDelete: {
			type: String,
			default: "Delete record",
		},
		msgBeforeDelete: {
			type: String,
			default: "Record deleted successfully",
		},
		msgAfterDelete: {
			type: String,
			default: "Record deleted successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showFooter: {
			type: Boolean,
			default: true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		}
	});
	const app = useApp(props);
	const page = useViewPage(props); // page hook
	//page state
	const { 
		item, // current record from store - Object
		loading, // api loading state
		pageReady, // api data loaded successfully
	} = toRefs(page.state);
	//page computed propties
	const {
		apiUrl, // page current api path
		currentRecord, // current page record  - Object
	} = page.computedProps
	//page methods
	const 
	{ 
		load, // load data from api
		deleteItem, // deleted current record
		exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
		moveToNextRecord, // load next record from api
		moveToPreviousRecord // load previous record from api
	} = page.methods
	function getActionMenuModel(data){
		return [
		{
			label: "Edit",
			command: (event) => { app.openPageDialog({ page:'report_requests/edit', url: `/report_requests/edit/${data.report_request_id}` , closeBtn: true }) },
			icon: "pi pi-pencil"
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.report_request_id) },
			icon: "pi pi-minus-circle"
		}
	]
	}
	onMounted(()=>{ 
		const pageTitle = "Report Requests Details";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
		load();
	});
</script>
<style scoped>
</style>
